import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Autocomplete, TextField, Box } from '@mui/material'
import MainCard from 'components/MainCard'
import React, { useState } from 'react'

function Enrollment() {
    const [selectedPlan, setSelectedPlan] = useState(null);
    const planOptions = [
        ...new Set([
            'Free',
            'Premium',
            'Pro'
        ])
    ];
    const allCoaches = [
        {
            coachId: 1,
            coachName: 'Coach - 1',
            plan: 'Free',
            status: 1,
            coachContact: 8397658742
        },
        {
            coachId: 2,
            coachName: 'Coach - 2',
            plan: 'Premium',
            status: 0,
            coachContact: 9397658746
        },
        {
            coachId: 3,
            coachName: 'Coach - 3',
            plan: 'Premium',
            status: 1,
            coachContact: 7397658744
        },
        {
            coachId: 4,
            coachName: 'Coach - 4',
            plan: 'Pro',
            status: 1,
            coachContact: 8397658746
        },
        {
            coachId: 5,
            coachName: 'Coach - 5',
            plan: 'Free',
            status: 0,
            coachContact: 9397658741
        },
    ];
    const filteredCoaches = selectedPlan
        ? allCoaches.filter((coach) => coach.plan === selectedPlan)
        : allCoaches;
  return (
    <MainCard>
      <Box sx={{ mb: 2, maxWidth: 300 }}>
        <Autocomplete
          options={planOptions}
          value={selectedPlan}
          onChange={(event, newValue) => setSelectedPlan(newValue)}
          renderInput={(params) => <TextField {...params} label="Filter by Plan" variant="outlined" />}
          clearOnEscape
          isOptionEqualToValue={(option, value) => option === value}
        />
      </Box>
      <TableContainer component={Paper}>
                <Table sx={{ minWidth: 800 }} aria-label="coach table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Coach Name</TableCell>
                      <TableCell>Plan</TableCell>
                      <TableCell>Contact</TableCell>                      
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>Status</TableCell>                      
                    </TableRow>
                  </TableHead>
                 <TableBody>
                    {filteredCoaches.length > 0 ? (
                      filteredCoaches.map((coach, index) => (
                        <TableRow key={coach.coachId}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>
                            {coach.coachName
                              .toLowerCase()
                              .split(' ')
                              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')}
                          </TableCell>
                        <TableCell>{coach.plan}</TableCell>
                          <TableCell>{coach.coachContact}</TableCell>
                              <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                                 <Chip label={coach.status === 1 ? 'Active' : 'Inactive'} color={coach.status === 1 ? 'success' : 'error'} />
                                               </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          <Lottie options={loaderOptions} height="25%" width="25%" />
                          <Box sx={{ mt: 2 }}>No coaches found matching your criteria.</Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody> 
                </Table>
              </TableContainer>
    </MainCard>
  )
}

export default Enrollment